import { useStore } from 'vuex'
import { computed } from 'vue'
import debounce from 'foundation/js/debounce'

export default {
    name: 'SearchAndCTA',
    props: {
        guid: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const inputText = computed({
            get: () => store.state.search.queries[props.guid] ?? '',
            set: (v) =>
                store.dispatch('search/setSearchQuery', {
                    guid: props.guid,
                    query: v
                })
        })

        const termInput = debounce(() => {
            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: inputText.value
            })
        }, 500)

        const createFundraise = function (e) {
            const currentUrl = location.href
            localStorage.setItem('flowheader__returnurl', currentUrl)
            location.href = e.target.href
        }

        const openPageOverlay = function(overlayType, e) {
            const overlayComponent = {
                'Login': 'loginOverlay',
                'CreateHold': 'opretHoldOverlay'
            }[overlayType]
            store.dispatch('main/openPageOverlay', {
                overlayContent: overlayComponent,
                returnTarget: e.currentTarget
            })
        }

        return {
            openPageOverlay,
            createFundraise,
            inputText,
            termInput
        }
    }
}
